import React, { memo } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import useLocales from 'src/hooks/useLocales';

import { FormGroupOptionProps } from '../types/elementSettingsTypes';

type ElementOptionsManagerProps = {
  options: string[] | FormGroupOptionProps[];
  type: 'simple' | 'formGroup';
  onAdd: () => void;
  onDelete: (index: number) => void;
  onChange: (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onFocus: (index: number, defaultValue: string, defaultOption?: string) => void;
  onBlur: (index: number, defaultValue: string) => void;
};

const ElementOptionsManager: React.FC<ElementOptionsManagerProps> = ({
  options,
  type,
  onAdd,
  onDelete,
  onChange,
  onFocus,
  onBlur,
}) => {
  const { t } = useLocales();

  const getOptionValue = (option: string | FormGroupOptionProps): string => type === 'simple' ? (option as string) : (option as FormGroupOptionProps).label;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {options.map((o, i) => (
        <Box
          key={`option-${i + 1}`}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <TextField
            fullWidth
            label={`${t('forms.option')} ${i + 1}`}
            placeholder={`${t('forms.writeOptionTitle')}`}
            value={getOptionValue(o)}
            size="small"
            onFocus={() =>
              type === 'simple'
                ? onFocus(i, `${t('forms.option')} ${i + 1}`, `${t('forms.writeOptionTitle')}`)
                : onFocus(i, `${t('forms.writeOptionTitle')}`)
            }
            onBlur={() => onBlur(i, `${t('forms.writeOptionTitle')}`)}
            onChange={(event) => onChange(i, event)}
            id={`Q4OIyP_${i}`}
          />

          <IconButton onClick={() => onDelete(i)} id="VhDi3p">
            <DeleteIcon fontSize="inherit" />
          </IconButton>
        </Box>
      ))}
      <Box>
        <Link
          sx={{ minWidth: 'max-content', p: 2 }}
          component="button"
          variant="body1"
          onClick={(event) => {
            event.preventDefault();
            onAdd();
          }}
          id="o8VMyO"
        >
          {t('forms.buttons.addAnotherOption')}
        </Link>
      </Box>
    </Box>
  );
};

export default memo(ElementOptionsManager);
